export enum BackendType {
    BLUE = 'BLUE',
    GTX = 'GTX',
    TIREMASTER = 'TIREMASTER',
    NONE = 'NONE'
}